// extracted by mini-css-extract-plugin
export default {"root":"IMp8B","input":"_3E0Cv"};